import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "./styles.scss";
import inovaLogo from "../../assets/inova@2x.png";
import api from "../../services/api";
import { solicitarCodigo } from "../../components/ResetSenhaLogin/loginSenhaReset";
import Preloader from "../../components/PreloaderGrids/Preloader";
import Swal from "sweetalert2";
import { FaWhatsapp } from "react-icons/fa";
import { FiEye, FiEyeOff } from "react-icons/fi";
function Login() {
  const navigate = useNavigate();

  const [values, setValues] = useState({
    email: "",
    senha: "",
  });
  const [mostrarSenha, setMostrarSenha] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleChange = ({ target }) => {
    setValues((prev) => ({
      ...prev,
      [target.name]: target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!values.email || !values.senha) {
      Swal.fire({
        icon: "warning",
        title: "Campos obrigatórios",
        text: "Preencha usuário e senha para continuar.",
        background: "rgba(12, 31, 44, 0.95)",
        color: "#ffffff",
        iconColor: "#0F73B2",
        showConfirmButton: false,
        timer: 3500,
        timerProgressBar: true,
        backdrop: "rgba(0,0,0,0.6)",
        customClass: {
          popup: "swal-tech"
        }
      });
      return;
    }

    const MIN_TIME = 1500;
    const startTime = Date.now();

    setLoading(true);

    try {
      const { data } = await api.post("/login", values);
      const { token, idU, nome, id, tipo } = data;

      localStorage.setItem("nome", nome);
      localStorage.setItem("inova", token);
      localStorage.setItem("id", id);
      localStorage.setItem("clientID", idU);
      localStorage.setItem("tipo", tipo);

















      // =========================
      // VALIDAR EMAIL
      // =========================

      const emailValido =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      const emailUsuario =
        data.email || "";

      const possuiEmailValido =
        emailValido.test(emailUsuario);

      // =========================
      // OBRIGAR ATUALIZACAO
      // =========================

      if (

        data.obrigarTrocaSenha ||

        !possuiEmailValido

      ) {

        setLoading(false);

        // =========================
        // ITENS NECESSARIOS
        // =========================

        const atualizacoes = [];

        // SENHA
        if (data.obrigarTrocaSenha) {

          atualizacoes.push(
            "Atualização de senha"
          );
        }

        // EMAIL
        if (!possuiEmailValido) {

          atualizacoes.push(
            "Cadastro de e-mail válido"
          );
        }

        // SEGURANÇA
        atualizacoes.push(
          "Verificação de segurança da conta"
        );

        // =========================
        // MODAL
        // =========================

        await Swal.fire({
          icon: "warning",

          title: "Atualização obrigatória",

          width: "580px",

          html: `
        <div style="
            text-align: left;
            color: #cbd5e1;
        ">

            <div style="
                margin-bottom: 20px;
                color: #aebdca;
                font-size: 14px;
                line-height: 1.7;
            ">
                Detectamos que algumas informações do seu
                cadastro precisam ser atualizadas.
            </div>


            <div style="
                padding: 18px;

                border-radius: 13px;

                background: #081722;

                border: 1px solid rgba(15, 115, 178, 0.22);

                box-shadow:
                    inset 0 1px 0 rgba(255,255,255,0.02);
            ">

                <div style="
                    display: flex;
                    align-items: center;
                    gap: 9px;

                    margin-bottom: 15px;

                    color: #e8edf2;

                    font-size: 14px;
                    font-weight: 600;
                ">

                    <span style="
                        width: 7px;
                        height: 7px;

                        border-radius: 50%;

                        background: #1f6fa9;

                        box-shadow:
                            0 0 8px rgba(31,111,169,0.7);
                    "></span>

                    Atualizações necessárias

                </div>


                <div style="
                    display: flex;
                    flex-direction: column;
                    gap: 11px;
                ">

                    ${atualizacoes.map(item => `
                        <div style="
                            display: flex;
                            align-items: center;
                            gap: 10px;

                            color: #b8c5d0;

                            font-size: 14px;
                        ">

                            <span style="
                                flex-shrink: 0;

                                width: 5px;
                                height: 5px;

                                border-radius: 50%;

                                background: #4b9bd0;
                            "></span>

                            <span>${item}</span>

                        </div>
                    `).join("")}

                </div>

            </div>


            <div style="
                margin-top: 20px;

                padding: 11px 13px;

                border-left: 2px solid #1f6fa9;

                background: rgba(31,111,169,0.05);

                border-radius: 0 7px 7px 0;

                color: #8293a2;

                font-size: 12.5px;

                line-height: 1.6;
            ">

                Para continuar utilizando a plataforma,
                atualize seus dados antes de prosseguir.

            </div>

        </div>
    `,

          confirmButtonText: "Atualizar cadastro",

          allowOutsideClick: false,

          allowEscapeKey: false,

          background: "#0b1b28",

          color: "#ffffff",

          iconColor: "#f59e0b",

          confirmButtonColor: "#1f6fa9",

          backdrop: `
        rgba(3, 10, 15, 0.78)
    `,

          customClass: {
            popup: "popup-atualizacao",
            title: "titulo-atualizacao",
            confirmButton: "botao-atualizacao"
          }
        });

        navigate("/atualizacao-senha");

        return;
      }














      const elapsed = Date.now() - startTime;
      const delay = Math.max(MIN_TIME - elapsed, 0);

      setTimeout(() => {
        setLoading(false);
        navigate("/maps");
      }, delay);

    } catch (error) {

      const elapsed = Date.now() - startTime;
      const delay = Math.max(MIN_TIME - elapsed, 0);

      setTimeout(() => {
        setLoading(false);

        Swal.fire({
          icon: "error",
          title: "Credenciais inválidas",
          text: "Verifique seu e-mail e senha.",
          background: "rgba(12, 31, 44, 0.95)",
          color: "#ffffff",
          iconColor: "#ff4d4f", // vermelho moderno
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
          backdrop: "rgba(0,0,0,0.65)",
          customClass: {
            popup: "swal-tech-error"
          }
        });

      }, delay);
    }
  };
  const formatarTelefone = (valor) => {
    // Remove tudo que não for número
    const numeros = valor.replace(/\D/g, "").slice(0, 11);

    if (numeros.length === 0) {
      return "";
    }

    // (11
    if (numeros.length <= 2) {
      return `(${numeros}`;
    }

    // (11) 99112
    if (numeros.length <= 7) {
      return `(${numeros.slice(0, 2)}) ${numeros.slice(2)}`;
    }

    // (11) 99112-1911
    return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(7, 11)}`;
  };

  const handleLoginChange = (e) => {
    const valor = e.target.value;

    // Se começou como telefone, aplica máscara
    if (
      /^\d/.test(valor) ||
      /^\(\d/.test(valor)
    ) {
      const telefoneFormatado = formatarTelefone(valor);

      handleChange({
        target: {
          name: "email",
          value: telefoneFormatado,
        },
      });

      return;
    }

    // Usuário ou e-mail
    handleChange(e);
  };




  return (
    <>
      <Preloader show={loading} text="Verificando dados de login..." />

      <div className="container-login">

        <div className="login-card">

          <img src={inovaLogo} alt="Inova Logo" className="login-logo" />

          <h2 className="login-title">Acesse sua conta</h2>
          <p className="login-subtitle">
            Entre para continuar na plataforma.
          </p>

          <form onSubmit={handleSubmit}>

            <div className="form-group">
              <label>Entrar com</label>
              <input
                type="text"
                name="email"
                value={values.email}
                onChange={handleLoginChange}
                autoComplete="username"
                placeholder="Usuário, e-mail ou telefone"
              />
            </div>

            <div className="form-group">
              <label>Senha</label>
              <div className="campo-senha">
                <input
                  type={mostrarSenha ? "text" : "password"}
                  name="senha"
                  value={values.senha}
                  onChange={handleChange}
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="botao-mostrar-senha"
                  onClick={() => setMostrarSenha((prev) => !prev)}
                  aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                >
                  {mostrarSenha ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            <div className="forgot-password">
              <button
                type="button"
                onClick={solicitarCodigo}
                className="link-button"
              >
                Esqueceu a senha?
              </button>
            </div>

            <button type="submit" className="btn-login">
              Entrar
            </button>


          </form>
        </div>
        <footer className="login-footer">

          <div className="login-footer-left">

            <span className="login-footer-brand">
              © {new Date().getFullYear()} Inova Rastreamento. Todos os direitos reservados.
            </span>

            <span className="login-footer-version">
              v1.3.4
            </span>
          

          </div>



          <div className="login-footer-right">

            <span className="login-footer-status">
              <span className="login-footer-status-dot"></span>
              Sistema operacional
            </span>


            <a
              href="https://wa.me/551124512452"
              target="_blank"
              rel="noopener noreferrer"
              className="login-footer-whatsapp"
              aria-label="Falar com o suporte pelo WhatsApp"
            >

              <FaWhatsapp />

              <span>
                Suporte
              </span>

            </a>

          </div>

        </footer>
      </div>
    </>
  );
}

export default Login; 